<template>
  <div id="app">
    <Header></Header>

    <div class="max-w-4xl mx-auto bg-white sm:shadow-md">
      <Picture imgClass="w-full object-cover object-top" src="img/schlosserei-raichle-team.jpg" />

      <div class="leading-relaxed">
        <div class="pb-8 px-content">
          <div class="flex justify-center">
            <h1 id="start" class="headline">Schlosserei Raichle</h1>
          </div>

          <p class="mt-4 text-gray-700">
            Wir sind seit 1865 ihr Ansprechpartner für Metallbau &
            Schlosserarbeiten in Dettingen/Teck. Unser Familienbetrieb wird in
            der fünften und sechsten Generation von Christian und Frieder
            Raichle geleitet. Unterstützung finden wir durch unsere fachkundigen
            und motivierten Mitarbeiter.
          </p>

          <div class="flex justify-center">
            <h1 id="konfigurator" class="headline">Balkongeländer Konfigurator</h1>
          </div>
          <p class="text-gray-700">
            Der schnellste Weg zu Ihrem neuen Balkongeländer.
          <ul class="list-none mt-2">
            <li class="point-up">
              <strong>Budget per Klick</strong><br />Mit unserem Konfigurator stellen Sie sich Ihr gewünschtes
              Balkongeländer zusammen
              und ermitteln das dafür notwendige Budget.
            </li>
            <li class="calender">
              <strong>Termin online</strong><br />Wenn Sie Ihr Wunschprojekt zum passenden Budget konfiguriert haben,
              buchen Sie bequem
              online Ihren telefonischen Erstberatungstermin mit uns.
            </li>
            <li class="video"><strong>Angebot mit Video</strong><br />Nach unserem Telefonberatungstermin und Klärung
              aller Details
              erhalten Sie Ihr detailliertes Angebot mit einem persönlichen Erklärvideo, das Sie sich wann und sooft Sie
              wollen ansehen können.</li>
          </ul>
          </p>
          <a class="btn mt-6 mb-4 flex justify-center bg-brand-blue hover:bg-brand-yellow hover:text-brand-blue text-white focus:outline-none focus:shadow-outline"
            href="https://www.balkongelaender-raichle.de/konfigurator">Ihr Balkongeländer konfigurieren</a>
        </div>

        <div class="pb-12 px-content">
          <div class="flex justify-center">
            <h1 id="neuigkeiten" class="headline">Neuigkeiten</h1>
          </div>

          <p class="mt-4 text-gray-700">
            Aktuelle Fotos, neue Projekte, Blicke hinter die Kulissen und regelmäßige Neuigkeiten finden Sie auf unserer
            <a class="text-brand-blue font-semibold underline"
              href="https://www.instagram.com/schlossereiraichle/">Instagram</a> oder <a
              class="text-brand-blue font-semibold underline"
              href="https://www.facebook.com/schlossereiraichle">Facebook</a> Seite.
          </p>

          <div class="flex flex-col sm:flex-row mt-4">
            <a href="https://www.instagram.com/schlossereiraichle/">
              <Picture src="img/socialmedia_banner.png" alt="Schlosserei Raichle Socialmedia Beiträge" imgClass="" />
            </a>
          </div>
        </div>

        <div class="bg-gray-yellow pt-8 pb-4 px-content">
          <div class="flex justify-center">
            <h1 id="leistungen" class="headline mt-0">Leistungen</h1>
          </div>
          <p class="mt-4 text-gray-700">
            Unser Meisterbetrieb ist nach DIN EN 1090 zertifiziert, was
            Voraussetzung für die Herstellung von tragenden Bauteilen ist. Wir
            bieten Ihnen eine kompetente & persönliche Beratung, individuelle
            Lösungen nach Wunsch, solide handwerkliche Ausführung, Qualität aus
            Meisterhand, CAD-Planung ihrer Projekte und statische Berechnungen.
          </p>

          <div class="flex flex-wrap my-4">
            <div v-bind:key="leistung.text" v-for="leistung in leistungen" class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1"
              v-on:click="open(leistung.linkUrl)">
              <div class="px-2 py-2 bg-white hover:shadow cursor-pointer">
                <div class="relative pb-full">
                  <Picture imgClass="absolute object-cover w-full h-full" :src="leistung.imageUrl"
                    :alt="leistung.text" />
                </div>
              </div>
              <h1 class="text-center mt-1 cursor-pointer">{{ leistung.text }}</h1>
            </div>
          </div>
        </div>

        <div class="px-content">
          <div class="flex justify-center">
            <h1 id="ueberuns" class="headline">Über uns</h1>
          </div>
          <p class="mt-4 text-gray-700">
            Der Raichle Familienbetrieb besteht seit 1865 und ist der älteste
            Handwerksbetrieb in Dettingen/Teck. Johann Georg Raichle, geb. am
            02. Juni 1830 betrieb eine Schmiede im Dettinger Ortskern, welche
            erst 1966 abgerissen wurde um einem größeren Gebäude Platz zu
            machen. An dieser Stelle stand noch bis Mitte 2016 unsere
            Bauschlosserei. Um den Anforderungen eines modernen
            Metallbaubetriebes gerecht zu werden und auch größere Projekte
            effizient bearbeiten zu können, konnten wir unsere Schlosserei
            räumlich bedeutend vergrößern und haben unseren Sitz jetzt im
            Dettinger Gewerbegebiet.
          </p>
          <p class="text-gray-700">
            Geleitet wird unser Familienbetrieb
            mittlerweile in der fünften und sechsten Generation von Christian
            und Frieder Raichle. Unterstützung finden wir durch unsere
            fachkundigen und motivierten Mitarbeiter. Im Zuge der
            Nachwuchsförderung und für die eigene Mitarbeiterfindung bilden wir
            Lehrlinge aus. Aufgrund der soliden handwerklichen Ausbildung, bei
            der alle unsere Werkstücke individuell gefertigt werden, werden
            unsere Auszubildenden zu praxisorientierten und selbstständigen
            Fachkräften herangezogen. Um ihnen qualitativ hochwertige Arbeit
            garantieren zu können legen unsere Mitarbeiter regelmäßig
            Schweißerprüfungen ab
          </p>
          <div class="flex flex-col sm:flex-row mt-4 mb-8">
            <div class="flex-1 sm:mr-2">
              <div class="relative pb-2/3">
                <Picture
                    src="img/schlosserei-halle.jpg"
                    alt="Halle Schlosserei Raichle"
                    imgClass="absolute object-cover h-full w-full"
                  />
              </div>
            </div>
            <div class="flex-1 sm:mr-2">
              <div class="flex-1 relative pb-2/3 mt-2 sm:mt-0 sm:ml-2">
                <Picture
                  src="img/chris_frieder_raichle.jpg"
                  alt="Christian und Frieder Raichle"
                  imgClass="absolute object-cover h-full w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CallToAction title="Metallbauer (m/w/d) gesucht!" linkText="Jetzt bewerben!"
        linkUrl="stellenanzeige-metallbauer-kirchheim-teck.html"></CallToAction>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Picture from "../components/Picture.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Picture,
  },
  data() {
    return {
      leistungen: [
        {
          text: "Balkone",
          imageUrl: "img/leistungen/balkon.jpg",
          linkUrl: "projekte.html?category=balkon"
        },
        {
          text: "Edelstahlarbeiten",
          imageUrl: "img/leistungen/edelstahlarbeiten.jpg",
          linkUrl: "projekte.html?category=edelstahlarbeiten"
        },
        {
          text: "Schmiedearbeiten",
          imageUrl: "img/leistungen/geschmiedetestreppengelaender.jpg",
          linkUrl: "projekte.html?category=schmiedearbeiten"
        },
        {
          text: "Treppen & Geländer",
          imageUrl: "img/leistungen/treppenaufgang_2.jpg",
          linkUrl: "projekte.html?category=treppen"
        },
        {
          text: "Überdachungen",
          imageUrl: "img/leistungen/glasdach.jpg",
          linkUrl: "projekte.html?category=ueberdachungen"
        },
        {
          text: "Zäune & Tore",
          imageUrl: "img/leistungen/gartentor.jpg",
          linkUrl: "projekte.html?category=zaeune_und_tore"
        },
        {
          text: "Gartenbereich",
          imageUrl: "img/leistungen/edelstahltopf.jpg",
          linkUrl: "projekte.html?category=garten"
        }
      ]
    };
  },
  methods: {
    open(url) {
      window.location.href = url;
    },
    getImgUrl(pic) {
      return require("../assets/" + pic);
    }
  }
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>
